<template>
  <div id="content">
    <section id="home" class="">
      <Cabecalho class="bg-home" />

      <div id="site-sections" class="bg-texture-fiber pt-5 sm:flex sm:justify-center sm:py-4">
        <div class="bg-orange sm:flex sm:w-1/5 sm:flex-wrap sm:content-center sm:justify-end sm:bg-transparent">
          <div
            class="py-2 text-center uppercase leading-none sm:px-4 sm:text-right sm:text-xs md:text-base lg:leading-normal">
            <span class="font-bold">
              Conheça
              <br class="hidden sm:inline" />
              os Programas
            </span>
            <br />
            de inclusão
            <br class="hidden sm:inline" />
            do detran-am
          </div>
        </div>

        <div class="h-screen-50 flex flex-wrap sm:h-auto sm:w-3/5 sm:flex-nowrap sm:items-center">
          <a class="flex h-1/3 w-full justify-center sm:inline-block sm:h-auto sm:w-auto" href="#cnh-social">
            <img alt="CNH Social" class="p-6 sm:p-3 lg:p-5 2xl:p-7" src="../assets/imgs/CNHSOCIAL_LOGO.png" />
          </a>
          <a class="flex h-1/3 w-full justify-center sm:inline-block sm:h-auto sm:w-auto" href="#motociclista-legal">
            <img
              alt="Motociclista Legal"
              class="p-6 sm:p-3 lg:p-5 2xl:p-7"
              src="../assets/imgs/CNHSOCIAL_MOTOCICLISTA.png" />
          </a>
          <a class="flex h-1/3 w-full justify-center sm:inline-block sm:h-auto sm:w-auto" href="#cnh-na-escola">
            <img alt="CNH na Escola" class="p-6 sm:p-3 lg:p-5 2xl:p-7" src="../assets/imgs/CNHSOCIAL_CNHnaEscola.png" />
          </a>
        </div>
      </div>
    </section>

    <section id="cnh-social">
      <div class="bg-texture-cnh py-6">
        <div class="w-full">
          <img alt="" class="w-full" src="../assets/imgs/TopoCNH-export-8.png" />
        </div>

        <div class="block sm:flex md:-mt-12 2xl:-mt-40">
          <div class="text-green-cnh w-full px-4 py-6 sm:order-2 sm:w-1/2 md:p-10 lg:py-20 xl:pr-32 2xl:pt-48">
            <h2 class="mb-3">
              <span class="text-4xl font-bold uppercase leading-tight lg:text-7xl 2xl:text-8xl"> CNH SOCIAL</span>
              <br />
              <span class="text-xl font-medium uppercase leading-tight lg:text-4xl 2xl:text-5xl 2xl:leading-snug">
                Mais que habilitação.
                <br />
                Uma nova direção.
              </span>
            </h2>
            <p class="leading-loose tracking-wide lg:text-2xl xl:text-3xl">
              Se você tem renda familiar de até 2 salários mínimos, inscreva-se no CNH Social,
              <span class="font-bold">
                tire a sua CNH ou mude de categoria
                <span class="lg:text-3xl">gratuitamente</span>
              </span>
              . Comece assim um novo caminho, com mais cidadania e oportunidades.
            </p>
          </div>

          <div id="homem-cnh-social" class="w-full sm:w-1/2"></div>
        </div>
        <div class="bg-inscricao-texture flex items-center justify-around px-4 md:px-8 py-8 text-right text-white md:block">
          <template v-if="mostrar_cadastro_perfil">
            <router-link class="link-destaque" to="/cadastro" v-if="inscricoes_ativas">Inscreva-se</router-link>
            <p class="my-4 inline text-lg font-bold text-red-300" v-else>INSCRIÇÕES ENCERRADAS</p>
          </template>
          <router-link class="links" to="/pre-requisitos-cnh">Pré-Requisitos</router-link>
        </div>
      </div>
    </section>

    <section id="motociclista-legal">
      <div class="bg-orange-texture py-6">
        <div class="block sm:flex">
          <div class="w-full px-4 py-6 sm:w-1/2 lg:py-10 lg:pb-24">
            <h2 class="mb-3 text-4xl uppercase leading-tight lg:text-7xl">
              Motociclista
              <br />
              <span class="font-bold">legal</span>
            </h2>
            <h3 class="my-10 text-3xl uppercase leading-tight lg:text-5xl">
              <span class="font-bold"> CAPACITAÇãO profissional para mototaxistas</span>
              e motofretistas
            </h3>
            <p class="my-10 lg:text-2xl lg:leading-loose lg:tracking-wide">
              Quem trabalha ou
              <span class="font-bold">
                deseja trabalhar como mototaxista ou motofretista agora vai ganhar capacitação grátis.
              </span>
              O Detran-AM vai fornecer gratuitamente o material didático, o capacete e o colete.
            </p>
            <p class="font-bold lg:text-2xl lg:leading-loose lg:tracking-wide">
              Este projeto isenta do pagamento das taxas relativas aos cursos obrigatórios do Detran-AM, para o
              exercício das profissões de mototaxista e motofretista. Esta isenção é válida somente para condutores
              amazonenses, maiores de 21 anos e habilitados há pelo menos dois anos na categoria A, AB, AC, AD e AE.
            </p>
          </div>

          <div id="motociclista" class="w-full sm:w-1/2"></div>
        </div>

        <div class="bg-white py-3 text-center md:text-right lg:px-24 lg:py-6">
          <router-link class="links" to="/pre-requisitos-motociclista"> Pré-Requisitos</router-link>
        </div>
      </div>
    </section>

    <section id="cnh-na-escola">
      <div class="block sm:flex">
        <div class="w-full px-4 py-6 text-white sm:order-2 sm:w-1/2 md:p-10 lg:py-20 xl:pr-32 2xl:pt-48">
          <h2 class="mb-3 text-5xl uppercase leading-none lg:text-7xl lg:leading-tight">
            CNH na
            <br />
            <span class="font-bold">Escola</span>
          </h2>
          <h3 class="my-10 font-bold uppercase leading-tight lg:text-5xl">
            ESCOLA DE CIDADANIA PARA FUTUROS CONDUTORES
          </h3>
          <p class="my-10 leading-loose tracking-wide lg:text-2xl 2xl:text-3xl">
            Os alunos que se interessarem em ingressar no programa terão aulas de legislação de trânsito com uma carga
            horária maior que nas autoescolas. Essas disciplinas são extracurriculares e serão ministradas ao longo dos
            três anos do Ensino Médio.
          </p>
          <p class="leading-loose tracking-wide lg:text-2xl 2xl:text-3xl">
            Ao final, se esse aluno já possuir 18 anos e tiver concluído o programa “CNH na Escola”, já poderá procurar
            o Detran-AM para realizar a prova teórica. Se aprovado, está apto a se matricular em uma autoescola para
            realizar a parte prática de direção.
          </p>
        </div>

        <div id="estudante" class="w-full sm:w-1/2"></div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import Cabecalho from '../components/Cabecalho.vue';
import util from '../util';

export default defineComponent({
  components: {
    Cabecalho,
  },
  setup() {
    const inscricoes_ativas = computed(() => util.get_inscricoes_ativas());
    const mostrar_cadastro_perfil = computed(() => util.get_mostrar_cadastro_perfil());
    return { inscricoes_ativas, mostrar_cadastro_perfil };
  },
});
</script>

<style lang="postcss" scoped>
@import url('../assets/css/styles.css');
</style>
